import { EnvironmentUrls } from 'Roblox';
import linkConstants from './linkConstants';

const { apiGatewayUrl } = EnvironmentUrls;
const getNavigationContainer = () => document.getElementById('navigation-container');
export default {
  debounceTimeout: 100,
  expiryTimeout: 5000,
  variationId: 1,
  trendingVariationId: 0,
  requestSuggestionUrl: {
    url: `${apiGatewayUrl}/games-autocomplete/v1/request-suggestion`,
    withCredentials: true
  },
  isSpecialTreatmentAutocompleteRestricted: (): boolean =>
    parseInt(getNavigationContainer().dataset.numberOfAutocompleteSuggestions, 10) === 7 &&
    (linkConstants.miscSearchLink as {
      pageSort: string[];
    }[])
      .reduce<string[]>((acc, link) => {
        acc.push(...link.pageSort);
        return acc;
      }, [])
      .reduce((r, keyword) => {
        return r || window.location.pathname.indexOf(keyword) > -1;
      }, false),
  isSpecialTreatment: (): boolean =>
    parseInt(getNavigationContainer()?.dataset.numberOfAutocompleteSuggestions, 10) === 7,
  numberOfSpecialTreatmentAutocompleteSuggestions: 3,
  isAutocompleteSuggestionsIXPTestEnabled: (): boolean =>
    parseInt(getNavigationContainer()?.dataset.numberOfAutocompleteSuggestions, 10) > 0,
  numberOfAutocompleteSuggestions: (): number =>
    parseInt(getNavigationContainer()?.dataset.numberOfAutocompleteSuggestions, 10) || 0
};
